import { cn } from 'lib/helpers/utility';

import { formattedValue } from 'components/shared/DatePicker/lib/formatedValue';
import Icon from 'components/shared/Icon/Icon';
import Popover from 'components/shared/Popovers/Popover/Popover';

const CalendarPopover = (props) => {
  const {
    value,
    isRange = false,
    selectWeekOnClick = false,
    format = 'MM/DD/YYYY',
    className,
    icon = 'calendar-mono',
    iconSize = 16,
    iconColor = 'neutral',
    textClassName,
    text = 'Select Date',
    position = 'right',
    button,
    children
  } = props;

  const outerButtonValue = formattedValue({ value, format, isRange: isRange || selectWeekOnClick });

  const CustomButton = button || (
    <div className={cn('flex cursor-pointer items-center gap-1', className)}>
      {icon && <Icon icon={icon} size={iconSize} color={iconColor} />}
      {(value || text) && (
        <span className={cn('text-sm text-neutral-900', textClassName)}>
          {value ? outerButtonValue : text}
        </span>
      )}
    </div>
  );

  return (
    <Popover
      isFixed
      position={position}
      className="flex items-center"
      panelClassName="p-0 shadow-[0px_0px_20px_0px_rgba(55,65,69,0.08)]"
      customButtonTrigger={CustomButton}>
      {children}
    </Popover>
  );
};

export default CalendarPopover;
